import { Injectable } from '@angular/core';
import { Scripts } from './symbol-search.interfaces';
import { ConfigurationService } from '../configuration/configuration.service';

@Injectable({
    providedIn: 'root'
})
export class SymbolLoadService {
    ScriptStore: Scripts[] = [
        { name: 'scrip_name_search', src: this.config.applicationUrls.scripMaster },
        { name: 'indices_name_search', src: this.config.applicationUrls.indicesMaster },
        { name: 'symbol_info_search', src: this.config.applicationUrls.symbolInfoMaster },

    ];

    private scripts: any = {};
    head = {
        key: ''
        , children: {}
    };

    constructor(
        private config: ConfigurationService
    ) {
        this.ScriptStore.forEach((script: any) => {
            this.scripts[script.name] = {
                loaded: false,
                src: script.src
            };
        });
    }

    load(...scripts: string[]) {
        const promises: any[] = [];
        scripts.forEach((script) => promises.push(this.loadScript(script)));
        return Promise.all(promises);
    }

    loadScript(name: string) {

        if (!this.scripts[name]) {
            // If name is not added it is url
            this.scripts[name] = {
                loaded: false,
                src: name
            };
        }

        return new Promise((resolve, reject) => {
            if (!this.scripts[name].loaded) {
                // load script
                const script: any = document.createElement('script');
                script.type = 'text/javascript';
                script.src = this.scripts[name].src;
                if (script.readyState) {  // IE
                    script.onreadystatechange = () => {
                        if (script.readyState === 'loaded' || script.readyState === 'complete') {
                            script.onreadystatechange = null;
                            this.scripts[name].loaded = true;
                            resolve({ script: name, loaded: true, status: 'Loaded' });
                        }
                    };
                } else {  // Others
                    script.onload = () => {
                        this.scripts[name].loaded = true;
                        resolve({ script: name, loaded: true, status: 'Loaded' });
                    };
                }
                script.onerror = (error: any) => resolve({ script: name, loaded: false, status: 'Loaded' });
                document.getElementsByTagName('head')[0].appendChild(script);
            } else {
                resolve({ script: name, loaded: true, status: 'Already Loaded' });
            }
        });
    }
}
